<template>
  <section v-if="results" class="section useful-resources">
    <div class="container mx-auto px-4">

      <h3 class="useful-resources__title">Useful Resources</h3>

      <div class="resources__cards">
        <Carsousel type="Resource" :payload="results" :settings="settings"></Carsousel>
      </div>
      
    </div>
  </section>
</template>

<script>
import algoliasearch from 'algoliasearch';
import Carsousel from '../carousel-layouts/Carousel.vue';

export default {
  components: {
    Carsousel
  },

  data() {
    return {
			client: false,
			index: false,
			index_name: (this.$config.test_env) ? 'resources-dev' : 'resources-live',
			searchObject: {
				hitsPerPage: 10,
				facets: ["featured"],
				facetFilters: [["featured:false"]]
			},
			results: false,
    }
  },
	created() {
		this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
		this.index = this.client.initIndex(this.index_name);

		this.index
			.search('', this.searchObject)
			.then((results) => {
				//console.log("we got initial hits:",results.hits,results.nbHits);
				console.log("featured resource search raw results:", results);
				if (results.nbHits > 0) {
					this.results = results.hits;
				} else {
					this.results = false;
				}
			});
	},

  computed: {
    settings() {
      return {
        width: '100%',
        gap: '1rem',
        pagination: false,
        arrows: false,
        perPage: 5,
        breakpoints: {
          480: {
            perPage: 1,
            drag: this.results.length >= 1
          },
          768: {
            perPage: 2,
            drag: this.results.length >= 2
          },
          1024: {
            perPage: 3,
            drag: this.results.length >= 3
          },
          1280: {
            perPage: 4,
            drag: this.results.length >= 4
          },
          1536: {
            perPage: 5,
            drag: this.results.length >= 5
          },
        }
      }
    }
  }
}
</script>
